import React from "react";

const Loader = () => (
  <div className='lds-ellipsis primary' aria-hidden='true'><div></div><div></div><div></div><div></div></div>
);

export default Loader;
